import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const UserService = {};

// khách hàng
UserService.listUser = function (page, perPage, columnFilter, keywords, sort) {
  return fetch({
    url: `${env.API_MSP}/users`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[record_status]": "O",
    },
  });
};

// Detail khách hàng
UserService.detailUser = function (id) {
  return fetch({
    url: `${env.API_MSP}/users/${id}`,
    method: "get",
  });
};

// Create khách hàng
UserService.createUser = function (data) {
  return fetch({
    url: `${env.API_MSP}/users`,
    method: "post",
    data,
  });
};

// Create tài khoản ngân hàng
UserService.createAccountBank = function (data, bu_code) {
  return fetch({
    url: `${env.API_MSP}/accounts`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit khách hàng
UserService.editUser = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/users/${id}`,
    method: "put",
    data,
  });
};

// Edit khách hàng
UserService.updateBuUser = function (data) {
  return fetch({
    url: `${env.API_MSP}/users/bu`,
    method: "post",
    data: {
      bu_code: data?.listBuCodeUpdate,
      user_id: data?.user_id, // user_code
    },
  });
};

// Delete khách hàng
UserService.deleteUser = function (id) {
  return fetch({
    url: `${env.API_MSP}/users/${id}`,
    method: "delete",
  });
};

// listAllUser
UserService.listAllUser = function (type_id) {
  return fetch({
    url: `${env.API_MSP}/users`,
    method: "get",
    params: {
      page: -1,
      sort: "code",
      "filter[record_status]": "O",
      //   "filter[type_id]": type_id,
    },
  });
};

// listUserBu
UserService.listUserBu = function (user_code) {
  return fetch({
    url: `${env.API_MSP}/users/bu/${user_code}`,
    method: "get",
  });
};

export default UserService;
